import React from 'react';

const Illustration = () => (

<svg width="225" height="115" viewBox="0 0 225 115" fill="none" xmlns="http://www.w3.org/2000/svg">
<title>Retailer Information</title>
<g id="Frame 1550">
<g id="Group">
<path id="Vector" d="M164.357 114.939H6.46094V58.2209L108.833 7.57324H164.357V114.939Z" fill="#EA576E"/>
<g id="Clip path group">
<mask id="mask0_683_5421" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="6" y="7" width="159" height="108">
<g id="clippath">
<path id="Vector_2" d="M164.357 114.939H6.46094V58.2209L108.833 7.57324H164.357V114.939Z" fill="white"/>
</g>
</mask>
<g mask="url(#mask0_683_5421)">
<g id="Group_2">
<path id="Vector_3" opacity="0.5" d="M164.398 -14.0342H108.18V121.528H164.398V-14.0342Z" fill="#FAEEED"/>
</g>
</g>
</g>
</g>
<g id="Group_3">
<path id="Vector_4" d="M170.791 0.0869141L108.18 0.463477L0.0683594 53.9354V61.4666L108.18 7.99473L170.791 7.61816V0.0869141Z" fill="#EA576E"/>
<g id="Clip path group_2">
<mask id="mask1_683_5421" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="0" y="0" width="171" height="62">
<g id="clippath-1">
<path id="Vector_5" d="M170.791 0.0869141L108.18 0.463477L0.0683594 53.9354V61.4666L108.18 7.99473L170.791 7.61816V0.0869141Z" fill="white"/>
</g>
</mask>
<g mask="url(#mask1_683_5421)">
<g id="Group_4">
<path id="Vector_6" d="M108.181 -10.0801H-12.9043V71.0691H108.181V-10.0801Z" fill="#8F051A"/>
</g>
</g>
</g>
</g>
<g id="Group_5">
<path id="Vector_7" d="M218.924 51.1113H108.18V114.939H218.924V51.1113Z" fill="#EA576E"/>
<g id="Clip path group_3">
<mask id="mask2_683_5421" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="108" y="51" width="111" height="64">
<g id="clippath-2">
<path id="Vector_8" d="M218.924 51.1113H108.18V114.939H218.924V51.1113Z" fill="white"/>
</g>
</mask>
<g mask="url(#mask2_683_5421)">
<g id="Group_6">
<path id="Vector_9" opacity="0.5" d="M257.092 48.8516H184.516V119.08H257.092V48.8516Z" fill="#FAEEED"/>
</g>
</g>
</g>
</g>
<g id="Group_7">
<path id="Vector_10" d="M224.941 43.5801H108.18V51.1113H224.941V43.5801Z" fill="#EA576E"/>
<g id="Clip path group_4">
<mask id="mask3_683_5421" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="108" y="43" width="117" height="9">
<g id="clippath-3">
<path id="Vector_11" d="M224.941 43.5801H108.18V51.1113H224.941V43.5801Z" fill="white"/>
</g>
</mask>
<g mask="url(#mask3_683_5421)">
<g id="Group_8">
<path id="Vector_12" d="M184.516 40.5674H102.727V52.8057H184.516V40.5674Z" fill="#8F051A"/>
</g>
</g>
</g>
</g>
<path id="Vector_13" opacity="0.5" d="M105.548 103.786H10.7852V107.552H105.548V103.786Z" fill="#FAD5D5"/>
<g id="Group_9">
<path id="Vector_14" d="M100.472 103.787H15.2988V53.9357L100.472 11.7607V103.787Z" fill="#FAD5D5"/>
<g id="Clip path group_5">
<mask id="mask4_683_5421" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="15" y="11" width="86" height="93">
<g id="clippath-4">
<path id="Vector_15" d="M100.472 103.787H15.2988V53.9357L100.472 11.7607V103.787Z" fill="white"/>
</g>
</mask>
<g mask="url(#mask4_683_5421)">
<g id="Group_10">
<path id="Vector_16" d="M-1.3418 104.446L98.0272 -8.38574L111.565 8.55957L14.2639 106.893L-1.3418 104.446Z" fill="white"/>
<path id="Vector_17" d="M19.1855 105.575L102.539 25.6934L102.915 35.484L22.1939 105.764L19.1855 105.575Z" fill="white"/>
</g>
</g>
</g>
</g>
<g id="Group_11">
<path id="Vector_18" d="M159.869 67.2676H131.512V111.173H159.869V67.2676Z" fill="#FAD5D5"/>
<g id="Clip path group_6">
<mask id="mask5_683_5421" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="131" y="67" width="29" height="45">
<g id="clippath-5">
<path id="Vector_19" d="M159.869 67.2676H131.512V111.173H159.869V67.2676Z" fill="white"/>
</g>
</mask>
<g mask="url(#mask5_683_5421)">
<g id="Group_12">
<path id="Vector_20" d="M102.754 122.413L168.866 47.3457L177.872 58.62L113.136 124.042L102.754 122.413Z" fill="white"/>
</g>
</g>
</g>
</g>
<path id="Vector_21" d="M125.667 31.2758C126.03 31.2758 126.03 30.7109 125.667 30.7109C125.304 30.7109 125.304 31.2758 125.667 31.2758Z" fill="#EA576E"/>
<path id="Vector_22" d="M133.947 86.4141H133.195V95.8281H133.947V86.4141Z" fill="#8F051A"/>
<path id="Vector_23" opacity="0.5" d="M164.398 111.173H126.873V114.938H164.398V111.173Z" fill="#FAD5D5"/>
<g id="Group_13">
<path id="Vector_24" d="M153.129 70.1807H138.253C138.045 70.1807 137.877 70.3493 137.877 70.5572V75.9345C137.877 76.1425 138.045 76.3111 138.253 76.3111H153.129C153.337 76.3111 153.505 76.1425 153.505 75.9345V70.5572C153.505 70.3493 153.337 70.1807 153.129 70.1807Z" fill="#EA576E"/>
<g id="OPEN">
<path id="Vector_25" d="M150.686 72.0527V74.4691H150.33L148.872 72.6255V74.459H148.432V72.0527H148.96L150.249 73.7032V72.0527H150.686Z" fill="white"/>
<path id="Vector_26" d="M145.887 74.459V72.0527H147.833V72.4459H146.34V72.9949H147.23V73.3914H146.34V74.0557H147.968V74.459H145.887Z" fill="white"/>
<path id="Vector_27" d="M143.213 74.459V72.0527H144.54C145.078 72.0527 145.379 72.3137 145.379 72.7882C145.379 73.2525 145.078 73.5371 144.54 73.5371H143.666V74.459H143.213ZM144.516 72.4594H143.666V73.1305H144.516C144.78 73.1305 144.912 72.9949 144.912 72.7949C144.912 72.578 144.783 72.4594 144.516 72.4594Z" fill="white"/>
<path id="Vector_28" d="M141.419 74.4993C140.698 74.4993 140.16 73.9774 140.16 73.2555C140.16 72.5336 140.705 72.0117 141.419 72.0117C142.133 72.0117 142.678 72.5336 142.678 73.2555C142.678 73.974 142.133 74.4993 141.419 74.4993ZM141.419 74.0858C141.9 74.0858 142.214 73.7164 142.214 73.2555C142.214 72.798 141.9 72.4252 141.419 72.4252C140.942 72.4252 140.627 72.798 140.627 73.2555C140.627 73.7198 140.939 74.0858 141.419 74.0858Z" fill="white"/>
</g>
</g>
</g>
</svg>

);

export default Illustration;
